import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  OnInit,
  OnDestroy,
} from "@angular/core";
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
} from "date-fns";
import {Subject, Subscription} from "rxjs";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from "angular-calendar";
import {AdminService, CommonService} from "../../_services/";
import {ToastrService} from "ngx-toastr";
import {DatePipe} from "@angular/common";
import {MatDialog, MAT_DIALOG_DATA} from "@angular/material";

import {ShowCalenderEventsDialogComponent} from "../../core/show-calender-events-dialog/show-calender-events-dialog.component";

const colors: any = {
  green: {
    primary: "#92d050",
    secondary: "#92d050",
  },

  blue: {
    primary: "#1e90ff",
    secondary: "#D1E8FF",
  },
  yellow: {
    primary: "#e3bc08",
    secondary: "#FDF1BA",
  },
};

@Component({
  selector: "app-calendar",
  templateUrl: "./calendar.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./calendar.component.scss"],
})
export class CalendarComponent {
  // @ViewChild('modalContent', {}) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();
  subscription: Subscription;
  modalData: {
    action: string;
    event: CalendarEvent;
  };

  actions: CalendarEventAction[] = [
    // {
    //   label: '<i class="fa fa-fw fa-pencil"></i>',
    //   onClick: ({ event }: { event: CalendarEvent }): void => {
    //     this.handleEvent('Edited', event);
    //   }
    // },
    // {
    //   label: '<i class="fa fa-fw fa-times"></i>',
    //   onClick: ({ event }: { event: CalendarEvent }): void => {
    //     // this.deleteCurrentEvent(event.id);
    //     this.events = this.events.filter(iEvent => iEvent !== event);
    //     this.handleEvent('Deleted', event);
    //   }
    // }
  ];

  refresh: Subject<any> = new Subject();

  events: CalendarEvent[] = [];
  activeDayIsOpen: boolean = false;
  items: any;
  assignmentList: [] = [];
  eventList: [] = [];
  newAssignmentList: [] = [];

  constructor(
    private modal: NgbModal,
    private _common: CommonService,
    public _admin: AdminService,
    public dialog: MatDialog
  ) {
    // code to get the current student data....
    this.getEventList();
  }

  ngOnInit() {}

  getEventList() {
    this.subscription = this._admin
      .getEventList(localStorage.getItem("uid"))
      .subscribe(
        (res) => {
          this._common.showLoader(false);
          this.items = res;
          this.events = [];
          for (let i in this.items) {
            this.events.push({
              start: new Date(this.items[i].payload.doc.data().start_date_time),
              title: `${
                this.items[i].payload.doc.data().calendar_event_type_name
              } | ${this.items[i].payload.doc.data().start_date_time} | ${
                this.items[i].payload.doc.data().address
              } | ${
                this.items[i].payload.doc.data().contact_first_name
                  ? this.items[i].payload.doc.data().contact_first_name
                  : ""
              } | ${
                this.items[i].payload.doc.data().contact_last_name
                  ? this.items[i].payload.doc.data().contact_last_name
                  : ""
              } | ${
                this.items[i].payload.doc.data().project_name
                  ? this.items[i].payload.doc.data().project_name
                  : ""
              } | ${
                this.items[i].payload.doc.data().showroom_name
                  ? this.items[i].payload.doc.data().showroom_name
                  : ""
              }`,
              color: colors.blue,
              actions: this.actions,
              allDay: true,
            });
          }
          console.log(this.events, "this.events");
          let element: HTMLElement = document.getElementById(
            "todayView"
          ) as HTMLElement;
          if (element != null) {
            element.click();
          }
        },
        (error) => {
          console.log("err!!!!!!!!!!!!!!!!");
        }
      );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  dayClicked({date, events}: {date: Date; events: CalendarEvent[]}): void {
    let newArray = [];
    newArray = this.events.filter(function (item) {
      return (
        item.start.getFullYear() == date.getFullYear() &&
        item.start.getMonth() == date.getMonth() &&
        item.start.getDate() == date.getDate()
      );
    });

    if (newArray.length != 0) {
      this.dialog.open(ShowCalenderEventsDialogComponent, {
        width: "auto",
        data: newArray,
      });
    }

    // if (isSameMonth(date, this.viewDate)) {
    //   if (
    //     (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
    //     events.length === 0
    //   ) {
    //     this.activeDayIsOpen = false;
    //   } else {
    //     this.activeDayIsOpen = true;
    //   }
    //   this.viewDate = date;
    // }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent("Dropped or resized", event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    // this.modalData = { event, action };
    // this.modal.open(this.modalContent, { size: 'lg' });
  }

  // openAddEventDialog(){
  //   this.popupService.openAddEventDialog({});
  // }

  // addEvent(): void {
  //   this.events = [
  //     ...this.events,
  //     {
  //       title: 'New event',
  //       start: startOfDay(new Date()),
  //       end: endOfDay(new Date()),
  //       color: colors.red,
  //       draggable: false,
  //       resizable: {
  //         beforeStart: true,
  //         afterEnd: true
  //       }
  //     }
  //   ];
  // }

  // Method to delete event,.....
  // deleteCurrentEvent(eventId){
  //   this.planner.deleteEvent(eventId).subscribe(res=>{
  //     this.toastr.success(`${res.statusMessage}`, "", {
  //       timeOut: 3000
  //     });
  //   },error=>{
  //     this.toastr.error(`${error.error.statusMessage}`, "", {
  //       timeOut: 3000
  //     });
  //   })
  // }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }
}
